import { TextSegment } from 'constants/WorkingModePathwaysConstants'

export const renderSegments = (segments: TextSegment[]) =>
  segments.map((segment, index) => (
    <span key={index} className={segment.bold ? 'font-bold' : undefined}>
      {segment.bold ?? segment.text}
    </span>
  ))
